import React, { VFC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {
  number: number | undefined
  className?: string
}

export const ProjectTableRowNumberTxt: VFC<Props> = ({ number, className }) => {
  return (
    <Txt
      sizeType="s"
      fontType="alphabet"
      className={`tw-font-bold ${number === 0 ? 'tw-text-standardText-disable' : ''} ${className}`}
    >
      {number?.toLocaleString()}
    </Txt>
  )
}
